import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, ILieferantEinstellungenState } from './state';

export const NAME = 'lieferantAdministration';
export const store: Module<ILieferantEinstellungenState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
